export default {"src":"/_next/static/media/Frame 2147227877 (2).6993d438.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};